import React, { useState, useEffect } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import Button from 'components/atoms/Button';
import PasswordStrength from 'components/molecules/PasswordStrength';
import { useParams } from 'react-router';
import Toast from 'components/molecules/Toast';
import { useNavigate } from 'react-router-dom';
import LoginTemplate from '../../templates/LoginTemplate';
import Field from '../../molecules/Field';
import Form, { useForm } from '../../molecules/Form';
import { StyledForm } from './SetPassword.styles';
import UserService from '../../../services/userService';

function SetPassword() {
  const navigation = useNavigate();
  const [form] = useForm();
  const [loading, setLoading] = useState('');
  const [state, setState] = useState({});
  const { token } = useParams();
  useEffect(() => {
    UserService.decryptToken(token).then(res => {
      if (res) {
        form.setFieldsValue({ email: res.email });
      }
    });
  }, [token]);
  const onSubmit = async e => {
    setLoading(true);
    UserService.setPassword({ payload: { password: e.password, token } })
      .then(res => {
        Toast({
          type: 'success',
          message: res.message ?? 'Password Reset Successfully',
        });
        navigation('/');
        setLoading(false);
      })
      .catch(ex => {
        setLoading(false);
        Toast({
          type: 'error',
          message: ex.message ?? 'Somthing went wrong',
        });
      });
  };
  useEffect(() => {
    if (state) {
      form.setFieldsValue({ ...state });
    }
  }, [form.getFieldValue('confirmPassword')]);
  return (
    <LoginTemplate title="Set Password" backButton>
      <StyledForm
        form={form}
        onTouched={e => {
          setState(_ => ({ ..._, ...e }));
        }}
        onSubmit={onSubmit}>
        <Form.Item
          rules={[{ required: true }]}
          bgLight
          disabled
          label="Email"
          name="email"
          placeholder="Email"
          prefix={<i className="material-icons-outlined">mail</i>}>
          <Field />
        </Form.Item>
        <Form.Item
          rules={[
            { required: true },
            {
              password: true,
            },
          ]}
          bgLight
          type="password"
          label="Password"
          name="password"
          placeholder="Password"
          onChange={event => {
            setState(_ => ({ ..._, password: event.target.value }));
            form.setFieldsValue({ password: event.target.value });
          }}
          value={state.password}
          prefix={<i className="material-icons-outlined">lock</i>}>
          <Field />
        </Form.Item>
        <PasswordStrength password={state.password ?? ''} />
        <Form.Item
          bgLight
          type="password"
          label="Confirm Password"
          name="confirmPassword"
          placeholder="Confirm Password"
          prefix={<i className="material-icons-outlined">lock</i>}
          rules={[
            { required: true, message: 'Please Confirm your password again' },
            {
              transform: x => x !== form.getFieldValue('password'),
              message: 'Passwords do not match',
            },
          ]}>
          <Field />
        </Form.Item>

        <Button loading={loading} type="primary" htmlType="submit" css="margin-bottom: 30px;">
          Set Password
        </Button>
      </StyledForm>
    </LoginTemplate>
  );
}

export default SetPassword;
